
const getters = {
  getUserProfile: state => state.user,
  getAgencyProfile: state => state.agency,
}

export default getters